import React from 'react'

import Form from '@managers/Form'
import { ISearch, ISearchDispatchers } from '@managers/SearchableSelectList'
import { EmailField, CharField, LocationField } from '@components/Fields'

interface IProps {
  searchForArea?: any
  locationSearch?: ISearch
  locationSearchDispatchers?: ISearchDispatchers
}

export default class ContactForm extends Form<IProps> {
  render() {
    const { locationSearch, locationSearchDispatchers } = this.props
    const { fields } = this.state

    return (
      <form className="Form" autoComplete="off" onSubmit={this.handleSubmit}>
        <EmailField
          name="email"
          field={fields.email}
          label="Email address"
          placeholder="Email address"
          icon={<i className="fas fa-envelope" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />
        {fields.phone_number ? (
          <CharField
            name="phone_number"
            field={fields.phone_number}
            label="Phone number"
            placeholder="Phone number"
            icon={<i className="fas fa-phone" />}
            onFocus={this.handleFieldFocus}
            onChange={this.handleFieldChange}
            onBlur={this.handleFieldBlur}
          />
        ) : null}
        <CharField
          name="name"
          field={fields.name}
          label="Name"
          placeholder="Name"
          icon={<i className="fas fa-user" />}
          onFocus={this.handleFieldFocus}
          onChange={this.handleFieldChange}
          onBlur={this.handleFieldBlur}
        />
        {fields.location && locationSearch && locationSearchDispatchers ? (
          <LocationField
            name="location"
            label="Where are you looking to buy?"
            field={fields.location}
            placeholder="Where are you looking to buy?"
            icon={<i className="fas fa-map-marker-alt" />}
            onFocus={this.handleFieldFocus}
            onChange={this.handleFieldChange}
            onBlur={this.handleFieldBlur}
            searchForArea={this.props.searchForArea}
            locationSearch={locationSearch}
            locationSearchDispatchers={locationSearchDispatchers}
          />
        ) : null}
        {this.props.children}
      </form>
    )
  }
}
